import React, { useState, useEffect, useContext } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import ToggleButton from '@material-ui/lab/ToggleButton';
import Tooltip from '@material-ui/core/Tooltip';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';

import Radio from '@material-ui/core/Radio';
import { green, red, blue, purple, indigo, grey } from '@material-ui/core/colors';

import { SessionContext } from "../context/session-context";


const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

const RedRadio = withStyles({
  root: {
    color: red[400],
    '&$checked': {
      color: red[600],
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const IndigoRadio = withStyles({
  root: {
    color: indigo[400],
    '&$checked': {
      color: indigo[600],
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const GreenRadio = withStyles({
  root: {
    color: green[400],
    '&$checked': {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const PurpleRadio = withStyles({
  root: {
    color: purple[400],
    '&$checked': {
      color: purple[600],
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const BlackRadio = withStyles({
  root: {
    color: grey[800],
    '&$checked': {
      color: grey[900],
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

export default function DataToolsPaper(props) {

  const useStyles = makeStyles((theme) => ({

      containerLabel:{
        marginTop:5,
        color:'#000',
        marginBottom:10,
      },
      containerHeader:{
        marginTop:5,
        marginLeft:20,
        color:'#000',
        marginBottom:10,
      },
      divider:{
        marginTop:10,
        marginBottom:10,
        marginLeft:0,
        marginRight:0,
      },

      textField: {
        minWidth: 140,
        marginTop:10,
      },
      textItemFont:{
        fontSize:11
      },
      properties:{
        padding:10,
      },
      propertiesItem:{
        padding:5,
        border: '1px solid #666',
      },
      propertiesLabel:{
        color:'#000',
      }

}));

  const classes = useStyles();
  const [sState, sDispatch] = useContext(SessionContext);
  const [outlineStyle, setOutlineStyle] = useState(''); 
  const [outlineThickness, setOutlineThickness] = useState(3); //Medium
  const [selectedTool, setSelectedTool] = useState('select');


  const handleOutlineStyleChange = (event) => {
    setOutlineStyle(event.target.value);
  };

  useEffect(() => {
    setOutlineStyle('#f44336');//Red
  },[]);

useEffect(() => {

  if (props.activetool === 'select'){

    let lineColour = sState.annotationStyle.outline.colour;
    let lineWidth = sState.annotationStyle.outline.width;

    const linehex = rgbStringToHex(lineColour);
    //console.log("lineColour"+lineColour+"; linehex="+linehex);
    setOutlineStyle(linehex);
    setOutlineThickness(parseInt(lineWidth));

  }
},[sState.annotationStyle.outline.colour, sState.annotationStyle.outline.width]);


  /**
   * Stores changes to outlinestyle
   */
  useEffect(() => {

    if ((outlineStyle !== '' && typeof outlineThickness !== 'undefined') && (outlineStyle !== sState.annotationStyle.outline.colour || outlineThickness !== sState.annotationStyle.outline.width)){
      //console.log("outlineStyle="+outlineStyle);
      const s = sState.annotationStyle;
      const c = hexToRgb(outlineStyle);
  
      s.outline.colour = "rgb("+c.r+","+c.g+","+c.b+")";
      s.outline.width = outlineThickness;
  
      //console.log("colourset: "+s.outline.colour+" "+s.outline.width);
  
      sDispatch({type: "setstyle", payload: { style: s }});
    }
  },[outlineStyle,outlineThickness]);


  const rgbStringToHex = (rgb) => {
    rgb = rgb.replace('rgb(', '');
    rgb = rgb.replace(')', '');
    const rgb_parts = rgb.split(',');
    return rgbToHex(parseInt(rgb_parts[0]),parseInt(rgb_parts[1]),parseInt(rgb_parts[2]));
  };

  const rgbToHex = (r, g, b) => {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  };

  const componentToHex = (c) => {
    var hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  };

  const hexToRgb = (hex) => {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b;
    });
  
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  return (
    <div className={classes.paper} >
          <Box className={classes.container} display="flex" flexDirection="row" justifyContent="center">
          <RedRadio
            checked={outlineStyle === '#f44336'}
            onChange={handleOutlineStyleChange}
            value="#f44336"
            name="radio-button"
            inputProps={{ 'aria-label': 'red' }}
          />
          <GreenRadio
            checked={outlineStyle === '#4caf50'}
            onChange={handleOutlineStyleChange}
            value="#4caf50"
            name="radio-button"
            inputProps={{ 'aria-label': 'green' }}
          />
          <IndigoRadio
            checked={outlineStyle === '#3f51b5'}
            onChange={handleOutlineStyleChange}
            value="#3f51b5"
            name="radio-button"
            inputProps={{ 'aria-label': 'blue' }}
          />
          <PurpleRadio
            checked={outlineStyle === '#673ab7'}
            onChange={handleOutlineStyleChange}
            value="#673ab7"
            name="radio-button"
            inputProps={{ 'aria-label': 'purple' }}
          />
          <BlackRadio
            checked={outlineStyle === '#212121'}
            onChange={handleOutlineStyleChange}
            value="#212121"
            name="radio-button"
            inputProps={{ 'aria-label': 'purple' }}
          />
          </Box>
          <Box className={classes.container} display="flex" flexDirection="row" justifyContent="center">
          <TextField id="outlineThickness" label="Outline thickness" value={outlineThickness} size="small" variant="outlined" InputProps={{classes: {input: classes.textItemFont}}} className={classes.textField} onChange={e => setOutlineThickness(e.target.value)} select >
              <MenuItem value={1}>Thin</MenuItem>
              <MenuItem value={3}>Medium</MenuItem>
              <MenuItem value={5}>Thick</MenuItem>
              <MenuItem value={8}>Extra Thick</MenuItem>
            </TextField>
          </Box>
    </div>
  );
}